import { API_URL } from '@/constants/config';
import { getAuthHeader } from '~/modules/common/utils/cookieUtils';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * Corpotate Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const corporateService = (http, cookies) => ({
  /**
   * Get User Agreement
   * @param {string} version agreement version
   */
  async getUserAgreement(version) {
    const queryParams = encodeQuery({ version: 'current' });
    const { data: result } = await http.$get(`${base}/metadata/tos${queryParams}`, {
      headers: getAuthHeader(cookies),
    });
    return result;
  },

  /**
   * Get Privacy Policy
   */
  async getPrivacyPolicy() {
    const { data: result } = await http.$get(`${base}/metadata/pages/static/privacy_policy`, {
      headers: getAuthHeader(cookies),
    });
    return result;
  },
});
